import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiFetch } from "../../utils/apiFetch";

import "./global/global.css";
import DealProgressIndicator from './DealProgressIndicator';

const ClientList = () => {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiFetch(
          `${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/deals/`
        );
        if (!response.ok) throw new Error("Failed to fetch deals");
        const data = await response.json();
        setDeals(data.deals || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };


  if (loading) {
    return (
      <div className="client-list-root">
        <div className="client-list-container">
          <div className="client-list-heading">
            <div className="lc">
              <h3 className="cl-rh">Deals</h3>
              <p className="cl-rh-sub">
                View and manage all your real estate deals.
              </p>
            </div>
          </div>
          <div className="client-list-table">
            <p className="loading">Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="client-list-root">
        <div className="client-list-container">
          <div className="client-list-heading">
            <div className="lc">
              <h3 className="cl-rh">Deals</h3>
              <p className="cl-rh-sub">
                View and manage all your real estate deals.
              </p>
            </div>
          </div>
          <div className="client-list-table">
            <p className="error">Error: {error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="client-list-root">
      <div className="client-list-container">
        <div className="client-list-heading">
          <div className="lc">
            <h3 className="cl-rh">Deals</h3>
            <p className="cl-rh-sub">
              View and manage all your real estate deals.
            </p>
          </div>
        </div>

        <div className="client-list-table">
          <div className="cl-table-container">
            <table className="cl-styled-table">
              <thead>
                <tr>
                  <th>Property Address</th>
                  <th>Buyer Name</th>
                  <th>Seller Name</th>
                  <th>Target Date</th>
                  <th>Deal Progress</th>
                  <th>Created</th>
                </tr>
              </thead>

              <tbody>
                {deals.length === 0 ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                      No deals found. Deals will appear here once they are created.
                    </td>
                  </tr>
                ) : (
                  deals.map((deal) => (
                    <tr key={deal.id} style={{ cursor: 'pointer' }}>
                      <td>
                        <Link to={`/deals/${deal.id}`} className="deal-row-link">
                          {deal.display_address || deal.property_address}
                        </Link>
                      </td>
                      <td>{deal.buyer_name || 'N/A'}</td>
                      <td>{deal.seller_name}</td>
                      <td>{formatDate(deal.target_date)}</td>
                      <td>
                        <DealProgressIndicator status={deal.status} />
                      </td>
                      <td>{formatDate(deal.created_at)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientList;
